var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "content" }, [
    _c(
      "p",
      [
        _c("Username", { attrs: { user: { nick: _vm.message.whois.nick } } }),
        _vm.message.whois.whowas
          ? _c("span", [_vm._v(" jasht linjes, informacionet e fundit:")])
          : _vm._e(),
      ],
      1
    ),
    _c(
      "dl",
      { staticClass: "whois" },
      [
        _vm.message.whois.account
          ? [
              _c("dt", [_vm._v("Nofka:")]),
              _c("dd", [_vm._v(_vm._s(_vm.message.whois.account))]),
            ]
          : _vm._e(),
        _c("dt", [_vm._v("ID maska:")]),
        _c(
          "dd",
          { staticClass: "hostmask" },
          [
            _c("ParsedMessage", {
              attrs: {
                network: _vm.network,
                text:
                  _vm.message.whois.ident + "@" + _vm.message.whois.hostname,
              },
            }),
          ],
          1
        ),
        _vm.message.whois.actual_hostname
          ? [
              _c("dt", [_vm._v("Actual host:")]),
              _c("dd", { staticClass: "hostmask" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://ipinfo.io/" + _vm.message.whois.actual_ip,
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [_vm._v(_vm._s(_vm.message.whois.actual_ip))]
                ),
                _vm.message.whois.actual_hostname != _vm.message.whois.actual_ip
                  ? _c("i", [
                      _vm._v(
                        "\n\t\t\t\t\t(" +
                          _vm._s(_vm.message.whois.actual_hostname) +
                          ")"
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          : _vm._e(),
        _vm.message.whois.real_name
          ? [
              _c("dt", [_vm._v("Emri real:")]),
              _c(
                "dd",
                [
                  _c("ParsedMessage", {
                    attrs: {
                      network: _vm.network,
                      text: _vm.message.whois.real_name,
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm.message.whois.registered_nick
          ? [
              _c("dt", [_vm._v("Eshte emer i regjistruar:")]),
              _c("dd", [_vm._v(_vm._s(_vm.message.whois.registered_nick))]),
            ]
          : _vm._e(),
        _vm.message.whois.channels
          ? [
              _c("dt", [_vm._v("Kanalet:")]),
              _c(
                "dd",
                [
                  _c("ParsedMessage", {
                    attrs: {
                      network: _vm.network,
                      text: _vm.message.whois.channels,
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm.message.whois.modes
          ? [
              _c("dt", [_vm._v("Modet:")]),
              _c("dd", [_vm._v(_vm._s(_vm.message.whois.modes))]),
            ]
          : _vm._e(),
        _vm.message.whois.special
          ? [
              _vm._l(_vm.message.whois.special, function (special) {
                return [
                  _c("dt", { key: special }, [_vm._v("Special:")]),
                  _c("dd", { key: special }, [_vm._v(_vm._s(special))]),
                ]
              }),
            ]
          : _vm._e(),
        _vm.message.whois.operator
          ? [
              _c("dt", [_vm._v("Operator:")]),
              _c("dd", [_vm._v(_vm._s(_vm.message.whois.operator))]),
            ]
          : _vm._e(),
        _vm.message.whois.helpop
          ? [
              _c("dt", [_vm._v("I gatshem per Ndihme:")]),
              _c("dd", [_vm._v("Yes")]),
            ]
          : _vm._e(),
        _vm.message.whois.bot
          ? [_c("dt", [_vm._v("Is a bot:")]), _c("dd", [_vm._v("Yes")])]
          : _vm._e(),
        _vm.message.whois.away
          ? [
              _c("dt", [_vm._v("Away:")]),
              _c(
                "dd",
                [
                  _c("ParsedMessage", {
                    attrs: {
                      network: _vm.network,
                      text: _vm.message.whois.away,
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm.message.whois.secure
          ? [_c("dt", [_vm._v("Lidhje e sigurte:")]), _c("dd", [_vm._v("Yes")])]
          : _vm._e(),
        _vm.message.whois.certfp
          ? [
              _c("dt", [_vm._v("Certificate:")]),
              _c("dd", [_vm._v(_vm._s(_vm.message.whois.certfp))]),
            ]
          : _vm._e(),
        _vm.message.whois.server
          ? [
              _c("dt", [_vm._v("Lidhur ne:")]),
              _c("dd", [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.message.whois.server) + " "),
                _c("i", [
                  _vm._v("(" + _vm._s(_vm.message.whois.server_info) + ")"),
                ]),
              ]),
            ]
          : _vm._e(),
        _vm.message.whois.logonTime
          ? [
              _c("dt", [_vm._v("Lidhur ne:")]),
              _c("dd", [
                _vm._v(_vm._s(_vm.localetime(_vm.message.whois.logonTime))),
              ]),
            ]
          : _vm._e(),
        _vm.message.whois.idle
          ? [
              _c("dt", [_vm._v("Nuk ka shkruar qe:")]),
              _c("dd", [
                _vm._v(_vm._s(_vm.localetime(_vm.message.whois.idleTime))),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }